import React from "react";
import { ColumnFilter } from "./ColumnFilter";
import {
  RenderBusEditable,
  RenderLocationEditable,
  RenderTradeEditable,
  RenderNoteEditable,
  RenderSignOutEditable,
  RenderExceptionsEditable,
  RenderVehicleTypeAndDescription,
  RenderWarningEditable,
  RenderSpecialNameAndEventDescription,
  RenderForeignDivision,
  RenderEarlyPullInCheckbox,
  RenderUnattendedRelief,
} from "./Renderables";

/**
 * Table column definitions for the bus assignments table
 * Extracted from MainTable.js for better organization
 *
 * @param {boolean} isSpecial - Whether this is a special route table
 * @param {boolean} displayUAR - Whether to display the UAR column
 * @returns {Array} Column configuration for react-table
 */
export const getTableColumns = (isSpecial, displayUAR) => {
  return [
    {
      Header: "Box",
      accessor: "boxNumber",
      Filter: ColumnFilter,
      width: 70,
    },
    isSpecial && {
      Header: "Special Name",
      accessor: "specialName",
      Filter: ColumnFilter,
      Cell: RenderSpecialNameAndEventDescription,
      disableFilters: true,
      width: 200,
    },
    {
      Header: "Run Number",
      accessor: "runNumber",
      Filter: ColumnFilter,
      width: 110,
    },
    {
      Header: "Route",
      accessor: "pulloutRouteAbbr",
      Filter: ColumnFilter,
      width: 90,
    },
    {
      Header: "Block",
      accessor: "blockNumber",
      Filter: ColumnFilter,
      width: 70,
    },
    {
      Header: "Time Out",
      accessor: "scheduledPulloutTimeFmt",
      Filter: ColumnFilter,
      disableFilters: true,
      width: 100,
    },
    {
      Header: "Time In",
      accessor: "scheduledPullinTimeFmt",
      Filter: ColumnFilter,
      disableFilters: true,
      width: 100,
    },
    {
      Header: "Mileage",
      accessor: "scheduledMiles",
      Filter: ColumnFilter,
      disableFilters: true,
      width: 100,
    },
    {
      Header: "Type",
      Cell: RenderVehicleTypeAndDescription,
      Filter: ColumnFilter,
      width: 75,
    },
    {
      Header: "Bus",
      accessor: "lastVehicle",
      Filter: ColumnFilter,
      Cell: RenderBusEditable,
      focus: "noteToOperator",
      width: 115,
    },
    {
      Header: () => (
        <div>
          Block <br /> Warnings
        </div>
      ),
      accessor: "warningMessages",
      Filter: ColumnFilter,
      disableFilters: true,
      width: 70,
      Cell: RenderWarningEditable,
    },
    {
      Header: "Location",
      accessor: "pulloutLocation",
      Filter: ColumnFilter,
      Cell: RenderLocationEditable,
      width: 120,
    },
    {
      Header: "Trade Reason",
      accessor: "tradeReason",
      Filter: ColumnFilter,
      Cell: RenderTradeEditable,
      disableFilters: true,
      width: 140,
    },
    {
      Header: () => (
        <div>
          Early <br /> Pull In
        </div>
      ),
      accessor: "earlyPullIn",
      Filter: ColumnFilter,
      Cell: RenderEarlyPullInCheckbox,
      disableFilters: true,
      width: 50,
    },
    {
      Header: "Exception",
      accessor: "pulloutVarianceReason",
      Filter: ColumnFilter,
      Cell: RenderExceptionsEditable,
      disableFilters: true,
      width: 100,
    },
    {
      Header: <div>Note to Operators</div>,
      accessor: "noteToOperator",
      Filter: ColumnFilter,
      Cell: RenderNoteEditable,
      disableFilters: true,
      width: 250,
    },
    {
      Header: "SignOut Comments",
      accessor: "signOutComments",
      Filter: ColumnFilter,
      Cell: RenderSignOutEditable,
      disableFilters: true,
      width: 250,
    },
    {
      Header: "FD",
      accessor: "foreignDivision",
      Filter: ColumnFilter,
      disableFilters: true,
      width: 40,
      Cell: RenderForeignDivision,
    },
    displayUAR && {
      Header: "UAR",
      accessor: "unattendedRelief",
      Filter: ColumnFilter,
      disableFilters: true,
      width: 40,
      Cell: RenderUnattendedRelief,
    },
  ].filter(Boolean);
};
